import { gql } from '@apollo/client';

export const QUERY = gql`
  query ListPaymentAccounts($scopeId: Int!, $scopeType: String!) {
    listPaymentAccounts(scopeId: $scopeId, scopeType: $scopeType) {
      businessType
      country
      currency
      currentProcessorAccountId
      externalAccountId
      id
      insertedAt
      nickname
      paymentsEnabled
      payoutsEnabled
      processor
      scopeId
      scopeType
      status
      legalEntityName
      firstName
      lastName
      paymentDescriptor
      payoutDescriptor
      bankName
      bankAccountNumberLast4
      bankRoutingNumber
    }
  }
`;
